import {
  defineComponent,
} from 'vue';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'RewardCheckbox',
  props: {
    /** 勾选状态 */
    checked: {
      type: Boolean,
      default: false,
    },
    /** 抵扣金额 */
    amount: {
      type: Number,
      default: 0,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const handleToggle = () => {
      emit('change', !props.checked);
    };

    return {
      handleToggle,
    };
  },
  render() {
    return (
      <div class={cx('reward-checkbox')} onClick={this.handleToggle}>
        <div
          class={cx('reward-checkbox__icon', {
            'reward-checkbox__icon--checked': this.checked,
          })}
        />
        <span class={cx('reward-checkbox__text')}>
          奖励金抵扣{this.amount}元
        </span>
      </div>
    );
  },
});
